import { render, staticRenderFns } from "./fixLeft.vue?vue&type=template&id=58cbe929&scoped=true&"
import script from "./fixLeft.vue?vue&type=script&lang=js&"
export * from "./fixLeft.vue?vue&type=script&lang=js&"
import style0 from "./fixLeft.vue?vue&type=style&index=0&id=58cbe929&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbe929",
  null
  
)

export default component.exports